import { render } from "./ValueProposition.vue?vue&type=template&id=2c554bb8&scoped=true"
import script from "./ValueProposition.vue?vue&type=script&lang=js"
export * from "./ValueProposition.vue?vue&type=script&lang=js"

import "./ValueProposition.vue?vue&type=style&index=0&id=2c554bb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c554bb8"]])

export default __exports__